<template>
	<v-container grid-list-md class="fill-height" fluid>
		<v-row align="center" justify="center">
			<v-col cols="12" sm="8" md="4">
				<app-status-alert></app-status-alert>
				<app-error-alert></app-error-alert>
				<ValidationObserver ref="obs" v-slot="{ invalid }">
					<v-form>
						<v-card>
							<v-card-title primary-title>
								{{ $t("title.forgot_password") }}
							</v-card-title>
							<v-divider></v-divider>
							<v-card-text>
								<v-layout row wrap>
									<v-flex xs12 class="py-5">
										{{
											$t(
												"message.forgot_password_full_description"
											)
										}}
									</v-flex>
									<v-flex xs12>
										<ValidationProvider
											name="email"
											rules="required|email"
											v-slot="{ errors, valid }"
										>
											<v-text-field
												:label="$t('Email')"
												v-model="item.email"
												prepend-icon="mdi-account"
												type="email"
												:error-messages="errors"
												:append-icon="
													valid ? 'mdi-check' : null
												"
											></v-text-field>
										</ValidationProvider>
									</v-flex>
								</v-layout>
							</v-card-text>
							<v-divider></v-divider>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn
									color="primary"
									@click.native="submit()"
									:loading="item.processing"
									:disabled="invalid"
								>
									<v-icon left>mdi-login</v-icon>
									{{ $t("label.email_password_reset_link") }}
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-form>
				</ValidationObserver>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import LayoutGuest from "../../layouts/guest.vue";
export default {
	layout: LayoutGuest,

	data() {
		return {
			item: this.$inertia.form({
				email: "limsocheat111@gmail.com",
			}),
		};
	},

	methods: {
		submit() {
			this.item.post(this.$route("password.email"));
		},
	},
};
</script>